import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _SidebarEditNavigationMenuModal;
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { fn, hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import DButton from "discourse/components/d-button";
import DModal from "discourse/components/d-modal";
import withEventValue from "discourse/helpers/with-event-value";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import I18n from "discourse-i18n";
import DropdownSelectBox from "select-kit/components/dropdown-select-box";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let SidebarEditNavigationMenuModal = (_class = (_SidebarEditNavigationMenuModal = class SidebarEditNavigationMenuModal extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "filter", _descriptor, this);
    _initializerDefineProperty(this, "filterDropdownValue", _descriptor2, this);
    _defineProperty(this, "filterDropdownContent", [{
      id: "all",
      name: I18n.t("sidebar.edit_navigation_modal_form.filter_dropdown.all")
    }, {
      id: "selected",
      name: I18n.t("sidebar.edit_navigation_modal_form.filter_dropdown.selected")
    }, {
      id: "unselected",
      name: I18n.t("sidebar.edit_navigation_modal_form.filter_dropdown.unselected")
    }]);
  }
  onFilterDropdownChange(value1) {
    this.filterDropdownValue = value1;
    switch (value1) {
      case "all":
        this.args.resetFilter();
        break;
      case "selected":
        this.args.filterSelected();
        break;
      case "unselected":
        this.args.filterUnselected();
        break;
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <DModal
      @title={{i18n @title}}
      @closeModal={{@closeModal}}
      class="sidebar__edit-navigation-menu__modal -large"
      ...attributes
    >
      <:belowModalTitle>
        <p class="sidebar__edit-navigation-menu__deselect-wrapper">
          <DButton
            @label="sidebar.edit_navigation_modal_form.deselect_button_text"
            @ariaLabel="sidebar.edit_navigation_modal_form.deselect_button_text"
            @action={{@deselectAll}}
            class="btn-flat sidebar__edit-navigation-menu__deselect-button"
          />

          {{@deselectAllText}}
        </p>
      </:belowModalTitle>

      <:belowHeader>
        <div class="sidebar__edit-navigation-menu__filter">
          <div class="sidebar__edit-navigation-menu__filter-input">
            {{icon
              "search"
              class="sidebar__edit-navigation-menu__filter-input-icon"
            }}

            <input
              {{on "input" (withEventValue (fn (mut this.filter)))}}
              {{on "input" (withEventValue @onFilterInput)}}
              type="text"
              value={{this.filter}}
              placeholder={{@inputFilterPlaceholder}}
              autofocus="true"
              class="sidebar__edit-navigation-menu__filter-input-field"
            />
          </div>

          <div class="sidebar__edit-navigation-menu__filter-dropdown-wrapper">
            <DropdownSelectBox
              @value={{this.filterDropdownValue}}
              @content={{this.filterDropdownContent}}
              @onChange={{this.onFilterDropdownChange}}
              @options={{hash showCaret=true disabled=@loading}}
              class="sidebar__edit-navigation-menu__filter-dropdown"
            />
          </div>
        </div>
      </:belowHeader>

      <:body>
        {{yield}}
      </:body>

      <:footer>
        <div class="sidebar__edit-navigation-menu__footer">
          <DButton
            @action={{@save}}
            @label="save"
            @disabled={{@saving}}
            class="btn-primary sidebar__edit-navigation-menu__save-button"
          />

          {{#if @showResetDefaultsButton}}
            <DButton
              @action={{@resetToDefaults}}
              @label="sidebar.edit_navigation_modal_form.reset_to_defaults"
              @icon="undo"
              @disabled={{@saving}}
              class="btn-flat btn-text sidebar__edit-navigation-menu__reset-defaults-button"
            />
          {{/if}}
        </div>
      </:footer>
    </DModal>
  
*/
{
  "id": "/3brROjd",
  "block": "[[[1,\"\\n    \"],[8,[32,0],[[24,0,\"sidebar__edit-navigation-menu__modal -large\"],[17,1]],[[\"@title\",\"@closeModal\"],[[28,[32,1],[[30,2]],null],[30,3]]],[[\"belowModalTitle\",\"belowHeader\",\"body\",\"footer\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"sidebar__edit-navigation-menu__deselect-wrapper\"],[12],[1,\"\\n          \"],[8,[32,2],[[24,0,\"btn-flat sidebar__edit-navigation-menu__deselect-button\"]],[[\"@label\",\"@ariaLabel\",\"@action\"],[\"sidebar.edit_navigation_modal_form.deselect_button_text\",\"sidebar.edit_navigation_modal_form.deselect_button_text\",[30,4]]],null],[1,\"\\n\\n          \"],[1,[30,5]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]],[[[1,\"\\n        \"],[10,0],[14,0,\"sidebar__edit-navigation-menu__filter\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"sidebar__edit-navigation-menu__filter-input\"],[12],[1,\"\\n            \"],[1,[28,[32,3],[\"search\"],[[\"class\"],[\"sidebar__edit-navigation-menu__filter-input-icon\"]]]],[1,\"\\n\\n            \"],[11,\"input\"],[16,2,[30,0,[\"filter\"]]],[16,\"placeholder\",[30,6]],[24,\"autofocus\",\"true\"],[24,0,\"sidebar__edit-navigation-menu__filter-input-field\"],[24,4,\"text\"],[4,[32,4],[\"input\",[28,[32,5],[[28,[32,6],[[28,[31,0],[[30,0,[\"filter\"]]],null]],null]],null]],null],[4,[32,4],[\"input\",[28,[32,5],[[30,7]],null]],null],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"sidebar__edit-navigation-menu__filter-dropdown-wrapper\"],[12],[1,\"\\n            \"],[8,[32,7],[[24,0,\"sidebar__edit-navigation-menu__filter-dropdown\"]],[[\"@value\",\"@content\",\"@onChange\",\"@options\"],[[30,0,[\"filterDropdownValue\"]],[30,0,[\"filterDropdownContent\"]],[30,0,[\"onFilterDropdownChange\"]],[28,[32,8],null,[[\"showCaret\",\"disabled\"],[true,[30,8]]]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]],[[[1,\"\\n        \"],[18,13,null],[1,\"\\n      \"]],[]],[[[1,\"\\n        \"],[10,0],[14,0,\"sidebar__edit-navigation-menu__footer\"],[12],[1,\"\\n          \"],[8,[32,2],[[24,0,\"btn-primary sidebar__edit-navigation-menu__save-button\"]],[[\"@action\",\"@label\",\"@disabled\"],[[30,9],\"save\",[30,10]]],null],[1,\"\\n\\n\"],[41,[30,11],[[[1,\"            \"],[8,[32,2],[[24,0,\"btn-flat btn-text sidebar__edit-navigation-menu__reset-defaults-button\"]],[[\"@action\",\"@label\",\"@icon\",\"@disabled\"],[[30,12],\"sidebar.edit_navigation_modal_form.reset_to_defaults\",\"undo\",[30,10]]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n  \"]],[\"&attrs\",\"@title\",\"@closeModal\",\"@deselectAll\",\"@deselectAllText\",\"@inputFilterPlaceholder\",\"@onFilterInput\",\"@loading\",\"@save\",\"@saving\",\"@showResetDefaultsButton\",\"@resetToDefaults\",\"&default\"],false,[\"mut\",\"yield\",\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/edit-navigation-menu/modal.js",
  "scope": () => [DModal, i18n, DButton, icon, on, withEventValue, fn, DropdownSelectBox, hash],
  "isStrictMode": true
}), _SidebarEditNavigationMenuModal), _SidebarEditNavigationMenuModal), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "filter", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "filterDropdownValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "all";
  }
}), _applyDecoratedDescriptor(_class.prototype, "onFilterDropdownChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFilterDropdownChange"), _class.prototype)), _class);
export { SidebarEditNavigationMenuModal as default };